import React, { useContext, useState } from 'react';
import './ShoppingItem.css';
import Image from '../shared/Image';
import preview from './../../public/image/preview.png'
import config from './../../config.json';
import MainContext from '../../context/mainContext';
import { priceFormat } from '../../util/showPriceFormat';
import { charsNormalize } from '../../util/charactorsNormalize';

const ShoppingItem = ({ _id, image, name, price, defaultCount }) => {

    const [count, setCount] = useState(defaultCount)
    const context = useContext(MainContext);

    const countHandler = (eValue, operator) => {
        let data = {
            _id,
            name,
            price,
            image,
            count
        }
        switch (operator) {
            case '+':
                context.addToShoppingCart({ ...data, count: count < 9999 ? count + 1 : count })
                setCount(prev => prev + 1);
                break;
            case '-':
                context.removeFromShoppingCart({ ...data, count: count - 1 })
                setCount(prev => prev - 1);
                break;
            case 'custom':
                if (eValue) {
                    context.addToShoppingCart({ ...data, count: eValue })
                    setCount(eValue);
                }
                else if (eValue === '') {
                    setCount(eValue)
                }
                break;
            default:
                break;
        }
    }
    const regix = /^[0-9\b]+$/;

    return (
        <div className='shopping-item'>
            <Image
                src={image ? `${config.api_address}/upload/${image}` : preview}
                width={60}
                height={60}
                borderRadius={'0 10px 10px 0'}
                style={{ objectFit: 'cover', opacity: image ? '1' : '.5' }}
            />
            <div className='middle col'>
                {name}
            </div>
            <div className="end-section">
                <div className="count-selection">
                    <button onClick={e => countHandler(e, '+')}
                        className='btn btn-success btn-sm'
                    ><i className="fa fa-plus"></i></button>
                    <div className='mx-1'>
                        <input
                            type='tel'
                            className='form-control ltr text-center'
                            style={{ width: '57px', fontSize: '.8rem' }}
                            value={count}
                            onChange={(e) => {
                                let normalized = '';
                                if (e.target.value) {
                                    normalized = charsNormalize(e.target.value);
                                }
                                if (normalized === '' || (regix.test(Number(normalized)) && Number(normalized) > 0 && Number(normalized) <= 9999)) {
                                    countHandler(normalized ? Number(normalized) : '', 'custom')
                                }
                            }}
                        />
                    </div>
                    <button onClick={e => countHandler(e, '-')}
                        className='btn btn-danger btn-sm'
                    ><i className={`${(count <= 1) ? "fa fa-trash" : "fa fa-minus"}`}></i></button>
                </div>
                <div className="price-item">{priceFormat(price * count)} <span style={{ marginRight: '5px' }}>{config.currencyType}</span></div>
            </div>
        </div>
    );
}

export default ShoppingItem;